function ImgSkills({link}){
    return(
        <img src={link} alt="" className="rounded-lg bg-white w-14 h-14  object-contain" />
    );
}

export default ImgSkills;